import { Role } from './roles.interface'
import {
    CaseSetComponent,
    ComponentComponent,
    EyewearComponent,
    GalvanicTreatmentComponent
} from '@surgetech-eu/core'
import { HandbookResolver, LabelResolver, ComponentResolverResolver, OrganizationResolver } from '@surgetech-eu/core'
import { PlatingMaterialsResolver } from '../galvman/plating-material.resolver'
import { SettingsResolver } from '../galvman/settings.resolver'
export interface MenuItem {
    name: string
    route: Array<string>
    title: string
}
export interface ExternalModule {
    path: string
    childPath: string
    component: any
    resolve?: any
    data?: any
}
export interface CatalogueItem {
    [key: string]: {
        menuItem: MenuItem
        externalModule: ExternalModule
    }
}
export const catalogueToRole = {
    eyedes: {
        eyewear: true,
        cases: true,
        component: true,
        galvanicTreatment: true
    },
    eyeman: {
        eyewear: true,
        cases: true,
        component: true,
        galvanicTreatment: true
    },
    galvman: {
        eyewear: true,
        component: false,
        galvanicTreatment: true
    },
    cmpman: {
        eyewear: true,
        component: true,
        galvanicTreatment: false
    }
}
export const cataloguesItems: CatalogueItem = {
    eyewear: {
        menuItem: {
            name: 'eyewearCatalog',
            route: ['/', 'catalog', 'eyewear'],
            title: 'Eyewear'
        },
        externalModule: {
            path: 'catalog',
            childPath: 'eyewear',
            component: EyewearComponent,
            resolve: {
                handbook: HandbookResolver,
                organizations: OrganizationResolver,
                labels: LabelResolver,
                libraries: ComponentResolverResolver
            },
            data: {
                labelContexts: [
                    'eyewear.catalogOptiTestViewModal',
                    'component.componentTable',
                    'caseSet.catalogCaseSetTable',
                    'galvanicTreatment.galvanicTreatmentTable',
                    'platingMaterial.platingMaterialTable'
                ]
            }
        }
    },
    cases: {
        menuItem: {
            name: 'caseCatalog',
            route: ['/', 'catalog', 'cases'],
            title: 'Cases'
        },
        externalModule: {
            path: 'catalog',
            childPath: 'cases',
            component: CaseSetComponent,
            resolve: {
                handbook: HandbookResolver,
                organizations: OrganizationResolver,
                labels: LabelResolver
            },
            data: {
                labelContexts: ['caseSet.catalogCaseSetTable']
            }
        }
    },
    component: {
        menuItem: {
            name: 'componentCatalog',
            route: ['/', 'catalog', 'component'],
            title: 'Components'
        },
        externalModule: {
            path: 'catalog',
            childPath: 'component',
            component: ComponentComponent,
            resolve: {
                handbook: HandbookResolver,
                organizations: OrganizationResolver,
                labels: LabelResolver,
                libraries: ComponentResolverResolver
            },
            data: {
                labelContexts: ['component.componentTable']
            }
        }
    },
    galvanicTreatment: {
        menuItem: {
            name: 'galvanicTreatmentCatalog',
            route: ['/', 'catalog', 'galvanicTreatment'],
            title: 'Galvanic Treatment'
        },
        externalModule: {
            path: 'catalog',
            childPath: 'galvanicTreatment',
            component: GalvanicTreatmentComponent,
            resolve: {
                handbook: HandbookResolver,
                organizations: OrganizationResolver,
                labels: LabelResolver,
                libraries: ComponentResolverResolver,
                platingMaterials: PlatingMaterialsResolver
            },
            data: {
                labelContexts: ['galvanicTreatment.galvanicTreatmentTable', 'platingMaterial.platingMaterialTable']
            }
        }
    }
}
export const GetCataloguesItems = type => {
    const catalogue: Role = {
        name: 'catalog',
        title: 'Catalogues',
        icon: 'ion-ios-book',
        pages: [],
        modules: {
            commonModules: [],
            externalModules: []
        }
    }
    Object.keys(cataloguesItems).map(key => {
        if (catalogueToRole[type][key]) {
            catalogue.pages.push(cataloguesItems[key]?.menuItem)
            catalogue.modules.externalModules.push(cataloguesItems[key]?.externalModule)
        }
    })
    return catalogue
}
